<template>
  <!-- 帮助中心 -->
  <div id="helpInfo" class="helpinfo">
    <div class="wrap-lg">
      <div class="clearfix">
        <div class="f_link">
          <div class="f_link">
            <div class="helpinfo-item">
              <div class="helpinfo-title">导航&nbsp;</div>
              <ul>
                <li>
                  <my-link href="/mall">日化商城</my-link>
                </li>
                <li>
                  <my-link href="/solution">解决方案</my-link>
                </li>
                <li>
                  <my-link href="/news">新闻资讯</my-link>
                </li>
                <li>
                  <my-link href="/serviceProject">关于我们</my-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="helpinfo-item">
            <div class="helpinfo-title">服务&nbsp;</div>
            <ul>
              <li>
                <my-link href="/reservice">推荐检测服务</my-link>
              </li>
              <li>
                <my-link href="/reorgs">推荐服务机构</my-link>
              </li>
              <li>
                <my-link href="/topic">专题推荐</my-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="f_link">
          <div class="helpinfo-item">
            <div class="helpinfo-title">资源中心</div>
            <ul>
              <li>
                <my-link href="/standard">检验标准</my-link>
              </li>
              <li>
                <my-link href="/laws">法律法规</my-link>
              </li>
              <li>
                <my-link href="/formula">产品配方</my-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="f_link">
          <div class="helpinfo-item">
            <div class="helpinfo-title">法律声明</div>
            <ul>
              <li>
                <my-link href="/deal">免责声明</my-link>
              </li>
              <li>
                <my-link href="/privacy">法律声明</my-link>
              </li>
              <li>
                <my-link href="/rights">知识产权</my-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="f_link">
          <div class="helpinfo-item helpinfo-email">
            <div class="helpinfo-title">联系客服&nbsp;</div>
            <ul>
              <li>
                <span>电话：{{commonUtils.getDictName('web_display_config','mobile')}}</span>
              </li>
              <li>
                <span>邮箱：{{commonUtils.getDictName('web_display_config','email')}}</span>
              </li>
              <li>
                <span>
                  地址：{{commonUtils.getDictName('web_display_config','address')}}
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div class="f_link">
          <div class="QRcode">
            <div class="helpinfo-title">联系我们&nbsp;</div>
            <div class="QRcode_img">
              <img src="../../assets/img/qcode_group.jpg">
            </div>
            <!--<div class="QRcode_img m-r">
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'help'
}
</script>

<style lang="scss" scoped>
  .helpinfo {
    width: 100%;
    min-width: 1226px;
    padding: 10px 0 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #ffffff;
    background: #32A08C;
    margin: 0 auto;
    line-height: 1;
    dd, ul, li {
      padding: 0;
      margin: 0;
    }
    ul li {
      padding: 0;
      margin: 0;
      list-style: none;
      margin-bottom: 17px;
      color: #ffffff;
      a {
        text-decoration: none;
      }
    }
  }

  .helpinfo:after {
    content: "\0020";
    display: block;
    visibility: hidden;
    clear: both;
    height: 0;
    overflow: hidden;
  }

  .helpinfo .helpinfo-item {
    float: left;
    width: 165px;
    font-size: 14px;
  }

  .helpinfo .helpinfo-item.helpinfo-email {
    width: 224px;
    padding-right: 20px;
  }

  .helpinfo .helpinfo-item li {
    margin-bottom: 17px;
    color: #ffffff;
  }

  .helpinfo .helpinfo-title {
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 58px;
  }

  .helpinfo ul a,
  .helpinfo ul span,
  .helpinfo ul em,
  .helpinfo ul label {
    color: #ffffff;
    font-size: 14px;
  }

  .helpinfo ul a:hover {
    font-weight: bold;
  }

  .helpinfo ul label {
    display: inline-block;
    position: relative;
    top: -21px;
  }

  .helpinfo ul em {
    display: inline-block;
    line-height: 22px;
    width: 157px;
    height: 44px;
  }

  .helpinfo .QRcode {
    float: right;
    border-left: 1px solid #606266;
    width: 268px;
    padding-left: 52px;
  }

  .helpinfo .QRcode .QRcode_img {
    float: left;
    margin-right: 35px;
  }

  .helpinfo .QRcode .QRcode_img.m-r {
    margin-right: 0;
  }

  .helpinfo .QRcode .QRcode_img img {
    width: 114px;
    height: 114px;
  }

  .helpinfo .QRcode .QRcode_img span {
    width: 114px;
    text-align: center;
    font-size: 14px;
    color: #606266;
    display: block;
  }

  .helpinfo .helpinfo_seo {
    padding-top: 35px;
    font-size: 14px;
    display: inline-flex;
  }

  .helpinfo .helpinfo_seo * {
    color: #606266;
  }

  .helpinfo .helpinfo_seo a:hover {
    color: #303133;
  }
</style>
